let utils = require("../../utils");
import AppHeader from "@/components/AppHeader";

export default {
  name: "user",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.getDepartment();
    this.search(false);
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(
      this.search,
      true,
      "button.next-page-search-btn"
    );
  },
  data() {
    return {
      companies: "",
      departments: [],
      users: [],
      selectedCompany: localStorage.company_id,
      selectedDepartment: "",
      selectedUserName: "",
      getCompanisEnd: false,
      getDepartmentsEnd: false,
      searchEnd: false,
      currentPage: 0,
      nextExist: false
    };
  },
  /** 画面遷移時 */
  beforeRouteLeave(to, from, next) {
    utils.scrollBottomSearchEventRemove(); // 最下部スクロール検索イベント削除
    next();
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
      this.getCompanisEnd = true;
    },
    async getDepartment() {
      this.getDepartmentsEnd = false;
      let data = {
        company_id: this.selectedCompany
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
      this.getDepartmentsEnd = true;
    },
    async search(addSearch) {
      let data = {
        company_id: this.selectedCompany,
        department_id: this.selectedDepartment,
        user_name: this.selectedUserName
      };
      if (addSearch) {
        this.currentPage += 1;
        data["current_page"] = this.currentPage;
        data["add_search"] = true;
      } else {
        this.searchEnd = false;
        this.currentPage = 0;
      }
      let res = await this.$store
        .dispatch("GET_USER", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });

      if (addSearch) {
        this.users = this.users.concat(res.users);
      } else {
        this.users = res.users;
        this.searchEnd = true;
      }
      this.nextExist = res.next_exist;
    },
    goUserDetail(userId) {
      this.$router.push({ path: `/user/${userId}` });
    },
    changeCompany() {
      this.selectedDepartment = "";
      this.getDepartment();
      this.search(false);
    }
  }
};
